import {
  GetCouponsRequestAction,
  GetCouponsSuccessAction,
  GetCouponsFailureAction,
  CouponsSuccessAnswer,
  ApplyCouponRequestAction,
  ApplyRetentionCouponRequestAction
} from './credits.types';

export const getCouponsRequest = (): GetCouponsRequestAction => ({
  type: 'GET_COUPONS_REQUEST'
});

export const getCouponsSuccess = (payload: CouponsSuccessAnswer): GetCouponsSuccessAction => ({
  type: 'GET_COUPONS_SUCCESS',
  payload
});

export const getCouponsFailure = (error: string): GetCouponsFailureAction => ({
  type: 'GET_COUPONS_FAILURE',
  error
});

export const applyCouponRequest = (couponCode: string): ApplyCouponRequestAction => ({
  type: 'APPLY_COUPON_REQUEST',
  payload: couponCode
});

export const applyRetentionCouponRequest = (
  couponCode: string
): ApplyRetentionCouponRequestAction => ({
  type: 'APPLY_RETENTION_COUPON_REQUEST',
  payload: couponCode
});
